<form name="form"
      autocomplete="off"
      (ngSubmit)="onFormSubmit(visitReviewReplyForm)"
      #visitReviewReplyForm="ngForm">

  <div class="form-group">
    <label class="h4 fw-bold"
           [translate]="'VISIT-REVIEWS.REPLY.INPUT-SALON-REPLY.LABEL'"></label>
    <p class="text-secondary"
       [translate]="'VISIT-REVIEWS.REPLY.HINT'"></p>
    <textarea class="form-control"
              autocomplete="off"
              type="text"
              rows="5"
              required
              trim
              id="reviewReplyText"
              #reviewReplyText="ngModel"
              name="reviewReplyText"
              [ngClass]="{ 'is-invalid': reviewReplyText.invalid && (reviewReplyText.dirty || visitReviewReplyForm.submitted) }"
              [(ngModel)]="visitReviewReplyFormData.replyText"
              validate-onblur
              [maxlength]="replyTextLimit"
              placeholder="{{'VISIT-REVIEWS.REPLY.INPUT-SALON-REPLY.PLACEHOLDER' | translate}}"></textarea>

    <div *ngIf="reviewReplyText.invalid && (reviewReplyText.dirty || visitReviewReplyForm.submitted)"
         class="text-danger"
         [@inOutAnimation]>

      <div *ngIf="reviewReplyText.errors.required"
           class="my-2"
           [translate]="'VISIT-REVIEWS.REPLY.INPUT-SALON-REPLY.ERROR-REQUIRED'">
      </div>
    </div>

    <span class="text-secondary">
      {{replyTextLimit - visitReviewReplyFormData.replyText.length}} / {{replyTextLimit}}
    </span>
  </div>

  <div class="form-check custom-control custom-checkbox mb-2">
    <input class="form-check-input custom-control-input"
           autocomplete="off"
           type="checkbox"
           value=""
           required
           id="areYouSureCheck"
           name="areYouSureCheck"
           #areYouSureCheck="ngModel"
           [ngClass]="{ 'is-invalid': areYouSureCheck.invalid && (areYouSureCheck.dirty || visitReviewReplyForm.submitted)}"
           [(ngModel)]="visitReviewReplyFormData.areYouSureChecked">
    <label class="form-check-label custom-control-label clickable"
           for="areYouSureCheck">
      <span [translate]="'VISIT-REVIEWS.REPLY.CHECKBOX-CONFIRM.LABEL'">
      </span>
      <span class="text-danger">
        *
      </span>
    </label>
  </div>

  <div *ngIf="areYouSureCheck.invalid && (areYouSureCheck.dirty || visitReviewReplyForm.submitted)"
       class="text-danger"
       [@inOutAnimation]>
    <div *ngIf="areYouSureCheck.errors.required"
         [translate]="'VISIT-REVIEWS.REPLY.CHECKBOX-CONFIRM.ERROR-REQUIRED'">
    </div>
  </div>

  <div class="text-end mt-3">
    <button type="submit"
            class="btn btn-primary"
            [translate]="'VISIT-REVIEWS.REPLY.BUTTON-SAVE'">
    </button>
  </div>
</form>
